<template>
    <div class="Ssfooter has-text-left">
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-1 is-3-mobile">
                    <router-link :to="`/privacy-policy`">
                        <p>Privacy Policy</p>
                    </router-link>
                </div>
                <div class="column is-1 is-3-mobile">
                    <router-link :to="`/cookie-policy`">
                        <p>Cookie Policy</p>
                    </router-link>
                </div>
                <div class="column is-1 is-3-mobile">
                    <router-link :to="`/legal-notices`">
                        <p>Legal Notices</p>
                    </router-link>
                </div>
                <div class="column is-3-mobile is-hidden-desktop">
                    <img src="/static/ssl.png">
                </div>
                <div class="column is-8 has-text-centered is-12-mobile">
                    <p v-if="this.$root._route.meta.policy">This website uses cookies. Please read more from cookie policy.</p>
                    <p v-else></p>
                </div>

                <div class="column is-1 is-12-mobile is-hidden-mobile">
                    <img src="/static/ssl.png">
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    components: {

    },
    name: 'Ssfooter',
    data() {
        return {
            msg: 'SarıkayaŞahin Web Development by Kaan KÜÇÜK',
        }
    },
    computed: {

    },
}
</script>

<style scoped>
.Ssfooter {
    background: rgba(29, 29, 29, 1);

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}

.Ssfooter a {
    color: #a2a2a2;
}

.Ssfooter .columns {
    display: flex;
    flex-direction: row;
    padding: 7px 0;
    flex-wrap: wrap;
}

.Ssfooter .column {
    padding: 15px 10px !important;
}

.columns .column:nth-last-child(1) img {
    max-height: 34px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
}

.column.is-8.has-text-centered p {
    margin-right: 275px;
    color: whitesmoke;
}
@media only screen and (max-width: 780px) {
    .is-4-mobile {
        text-align: center;
    }
    .column.is-8.has-text-centered p {
    margin-right: 0px;
    }
    p {
        font-size: 0.9rem;
    }
    .columns .column:nth-last-child(1) img {
    max-height: 34px;
    position: relative;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    }
    .columns .column:nth-last-child(1) {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Ssfooter {
    background: rgba(29, 29, 29, 1);
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    max-height: 110px;
    }
    .Ssfooter .column {
    padding: 5px 10px !important;
    }
    .column.is-3-mobile img {
        height: 25px;
        margin: 5px;
    }
    .column.is-3-mobile {
    justify-content: center;
    align-items: center;
    display: flex;
    }
}
</style>



// WEBPACK FOOTER //
// footer.vue?5beb1d0e